// src/pages/ComoFunciona.jsx

import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../utils/ComoFunciona.css';

// Imágenes para el carrusel
import img1 from '../components/public/Comofunciona.gif'; // Reemplaza con la ruta correcta
import img2 from '../components/public/Imagen.png'; // Reemplaza con la ruta correcta
import img3 from '../components/public/funcion.gif'; // Reemplaza con la ruta correcta
import img4 from '../components/public/img1.png'; // Reemplaza con la ruta correcta

const ComoFunciona = () => {
  return (
    <div className="comofunciona-container">
      <Carousel
        interval={5000}
        prevIcon={<span className="carousel-control-prev-icon" aria-hidden="true"></span>}
        nextIcon={<span className="carousel-control-next-icon" aria-hidden="true"></span>}
      >
        <Carousel.Item>
          <div className="carousel-content">
            <div className="text-box">
              <h2>¿Cómo Funciona el Sistema?</h2>
              <p>
                <strong>Sistema de Gestión de Agua Potable:</strong> Un Sistema de Gestión de Agua Potable para Ingreso de Consumos, Cobros e Impresión de Planillas de Pago es una herramienta tecnológica diseñada para automatizar y facilitar las operaciones administrativas relacionadas con el suministro de agua potable. Este tipo de sistema permite registrar consumos, calcular tarifas, gestionar cobros y emitir facturas o planillas de pago para los usuarios.
              </p>
            </div>
            <img src={img1} alt="Funcionamiento de SmartPlate" className="carousel-image" />
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="carousel-content">
            <div className="text-box">
              <ul>
                <li>
                  <strong>Ingreso de Consumos:</strong> Registro del consumo de agua potable medido por dispositivos como medidores de agua. Funcionalidad para cargar manualmente o de forma automática los datos de consumo por usuario o cliente. Monitoreo histórico del consumo para análisis y optimización.
                </li>
                <li>
                  <strong>Cálculo de Cobros:</strong> Aplicación de tarifas de acuerdo con las normativas locales y el tipo de cliente (residencial, comercial, industrial). Funciones para calcular recargos, descuentos o ajustes según políticas vigentes. Generación automática de montos a pagar con base en el consumo registrado.
                </li>
              </ul>
            </div>
            <img src={img4} alt="Interfaz de SmartPlate" className="carousel-image" />
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="carousel-content">
            <div className="text-box">
              <ul>
                <li>
                  <strong>Consulta de Datos del Cliente:</strong> Ingresa el código de medidor y la cédula del cliente para obtener información personalizada sobre el consumo de agua. Esto permite un acceso rápido y seguro a los datos.
                </li>
                <li>
                  <strong>Visualización de Información:</strong> Una vez ingresados los datos, se despliega la lectura anterior y actual del consumo, el período correspondiente, el tipo de consumo (doméstico o comercial), subtotal, multas, valor total y estado del pago.
                </li>
              </ul>
            </div>
            <img src={img3} alt="Consulta de Datos del Cliente" className="carousel-image" />
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="carousel-content">
            <div className="text-box">
              <ul>
                <li>
                  <strong>Gestión Simplificada:</strong> La interfaz permite a los usuarios revisar su historial de consumo y pagos pendientes, asegurando claridad y facilidad de uso.
                </li>
                <li>
                  <strong>Estado del Pago:</strong> Indica claramente si el pago está pendiente o completado, facilitando el seguimiento y la regularización de cuentas.
                </li>
              </ul>
            </div>
            <img src={img2} alt="Estado del Pago y Consumo" className="carousel-image" />
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default ComoFunciona;
